import { CheckinEntry } from '../../../app/types'
import useAppSelector from '../../../hooks/useAppSelector'
import { getS3AllTeamEntriesSelector } from '../../data/dataSlice'

export function useTeamEntries(selectedEntry: CheckinEntry) {
  const allTeamEntries = useAppSelector(getS3AllTeamEntriesSelector)
  return selectedEntry?.teamId
    ? allTeamEntries?.filter(e => e.team_id === selectedEntry.teamId) : []
}
